import WfError from '../../components/wf-error';

import './index.scss';

interface WfSubmitBtnProps {
  disabled: boolean;
  loading: boolean;
  error: boolean;
  t: (key: string) => string;
  onClick: () => void;
}

function WfSubmitBtn(props: WfSubmitBtnProps) {
  const { disabled, loading, error, t, onClick } = props;

  return (
    <div className="wf-submit-container">
      <button className="wf-submit-btn" disabled={disabled || loading} onClick={onClick}>
        {loading ? t('webform.SUBMITTING...') : t('webform.SUBMIT')}
      </button>

      <WfError error={error} t={t} />
    </div>
  );
}

export default WfSubmitBtn;
